<template>
  <v-container>
    <v-row dense>
      <v-col cols="auto" class="mx-auto">
        <h2 class="font-weight-bold">{{ cuestionario.Titulo }}</h2>
      </v-col>
    </v-row>

    <v-alert
      v-if="!puedeVerCuestionario && !loading"
      type="error"
      border="left"
      prominent
      class="mx-auto my-4"
      style="max-width: 900px"
    >
      Este formulario no está habilitado para tu usuario, es posible que ya lo hayas contestado o sea un error, cualquier duda o modificacion contacta con RRHH.
    </v-alert>

    <v-card
      v-if="puedeVerCuestionario && !loading"
      class="mx-auto my-4 pa-4"
      max-width="900"
    >

      <v-row dense>
        <v-col cols="auto" class="mx-auto">
          <img :src="logoSrc" style="max-height:60px" />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="auto" class="mx-auto">
          <p>Hola, <b>{{ perNombre }}</b></p>
        </v-col>
      </v-row>

      <!-- Descripción / Texto legal mostrado -->
      <v-row dense v-if="descripcionHtml">
        <v-col cols="12" md="10" class="mx-auto">
          <v-alert border="left" type="info" colored-border>
            <div v-html="descripcionHtml"></div>
          </v-alert>
        </v-col>
      </v-row>

      <v-progress-linear v-if="loading" indeterminate color="primary" class="my-4"/>

      <v-card v-if="!loading" class="mx-auto my-4 pa-4" max-width="900">
        <!-- P35: Decisión -->
        <div class="mb-2 font-weight-bold">Por favor, seleccione una de las siguientes opciones en funcion de si acepta o no realizarse el reconocimiento médico. Tendra que asistir a un centro acreditado, y aunque serán horas remuneradas, deberá ser en horario contrario a tu turno de trabajo, siempre que sea posible.</div>
        <v-radio-group v-model="decision" row>
          <v-radio label="Sí" value="SI"/>
          <v-radio label="No" value="NO"/>
        </v-radio-group>
        <v-alert type="info" dense outlined class="my-4">
          <div class="d-flex justify-space-between align-center">
            <span>Este reconocimiento incluye condiciones legales.</span>
            <v-btn small text color="primary" @click="dialogLegal = true">Ver más</v-btn>
          </div>
        </v-alert>

        <!-- Modal con todo el texto legal -->
        <v-dialog v-model="dialogLegal" max-width="700px">
          <v-card>
            <v-card-title class="headline">Información legal</v-card-title>
            <v-card-text style="white-space: pre-line; text-align: justify; font-size: 13px;">
              Las medidas de vigilancia y control de la salud de los trabajadores se llevarán a cabo respetando siempre el derecho a la intimidad y a la dignidad de la persona del trabajador, así como de la confidencialidad de toda la información relacionada con su estado de salud. 
              
              Los resultados obtenidos serán comunicados a los trabajadores afectados, no pudiendo ser los datos empleados de forma discriminatoria ni en perjuicio para la persona trabajadora. 
              
              El acceso a la información médica de carácter personal se limitará al personal sanitario y a las autoridades sanitarias que lleven a cabo la vigilancia y control de la salud de los trabajadores, sin que pueda facilitarse esta información al empresario o a otras personas sin consentimiento expreso del trabajador. 
              
              No obstante, lo anterior, el empresario y las personas u órganos con responsabilidades en materia de prevención, serán informados de las conclusiones que se deriven de los reconocimientos efectuados en relación con la aptitud del trabajador para el desempeño del puesto de trabajo o con la necesidad de introducir o mejorar las medidas de protección y prevención, a fin de que puedan desarrollar correctamente sus funciones en materia preventiva. 
              
              Las medidas de vigilancia y control de la salud de las personas trabajadoras se llevarán a cabo por personal sanitario con competencia técnica, formación y capacidad acreditada, aplicando los protocolos específicos de vigilancia de la salud. 
              
              El trabajador ha sido informado que se encuentra protegido por la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales (LOPDGDD), y sus datos se incorporan al correspondiente fichero gestionado por este Departamento, autorizándole a la utilización y tratamiento de los mismos, para cualquier finalidad relacionada con la Salud Laboral. 
              
              El Departamento de Salud Laboral de SU EMPRESA, garantiza la seguridad en la custodia, almacenamiento y utilización de los datos, restringiendo la difusión de los mismos exclusivamente para fines de vigilancia y control de la salud, en cumplimiento de la LOPDGDD. 
              
              A la persona trabajadora le asisten los derechos Arco (acceso, oposición, rectificación y cancelación) de sus datos personales, bastando para su ejercicio comunicación por escrito dirigida a éste Departamento.
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn text color="primary" @click="dialogLegal = false">Cerrar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>


        <!-- P36: Disponibilidad (si decisión SI) -->
        <template v-if="decision === 'SI'">
          <!-- <v-alert type="info" dense outlined class="my-4">
            <div class="d-flex justify-space-between align-center">
              <span>Indicaciones para detallar tu disponibilidad.</span>
              <v-btn small text color="primary" @click="dialogDisponibilidad = true">Ver más</v-btn>
            </div>
          </v-alert> -->
          <div class="mb-2">Para poder gestionar de manera más rápida los reconocimientos médicos, por favor detalla tu disponibilidad en las próximas semanas, indicando días y franjas horarias, así podremos ajustarnos mejor a vuestras necesidades. Recuerda que una vez que está asignada la hora, no presentarse o cambiarla con menos de 48h conlleva un coste adicional. 
                
                A la cita hay que acudir sin haber ingerido alimentos en las 4 últimas horas. Os pedimos responsabilidad con la solicitud.
                
                Elige 4 dias en los que tengas disponibilidad, y desde RRHH te asignarán uno de ellos.</div>

          <!-- Modal con el texto completo -->
          <!-- <v-dialog v-model="dialogDisponibilidad" max-width="700px">
            <v-card>
              <v-card-title class="headline">Instrucciones de disponibilidad</v-card-title>
              <v-card-text style="white-space: pre-line; text-align: justify; font-size: 13px;">
                
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn text color="primary" @click="dialogDisponibilidad = false">Cerrar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog> -->
          <v-divider class="my-4"/>
          <div class="mb-2 font-weight-bold">Indica tu disponibilidad</div>
          <!-- Para simplificar: calendario multi-fecha -->
          <!-- <v-row>
            <v-col cols="12" md="12">
              <v-date-picker v-model="fechas" :min="hoyISO" multiple full-width />
            </v-col>
            <v-col cols="12" md="12">
              <div class="mb-2 font-weight-bold">Franja preferente</div>
              <v-select
                v-model="franja"
                :items="[
                  { label: 'Mañana (08:00 - 11:00)', value: 'Mañanas' },
                  { label: 'Mediodia (11:00 - 14:00)', value: 'Mediodia' },
                  { label: 'Tarde (14:00 - 17:00)', value: 'Tarde' }
                ]"
                item-text="label"
                item-value="value"
                label="Franja preferente"
                dense
                outlined
              />
            </v-col>
          </v-row> -->
          <!-- Selector de 1 día + franja y botón para añadir -->
          <v-row dense>
            <v-col cols="12" md="6">
              <div class="mb-2 font-weight-bold">Elige un día</div>
              <v-date-picker
                v-model="selFecha"
                :min="hoyISO"          
                locale="es-ES"
                :first-day-of-week="1"
                :allowed-dates="allowedDates"
                full-width
              />
            </v-col>
            <v-col cols="12" md="6">
              <div class="mb-2 font-weight-bold">Elige franja para ese día</div>
              <v-select
                v-model="selFranja"
                :items="[
                  { label: 'Mañana (08:00 - 11:00)', value: 'Mañanas' },
                  { label: 'Mediodia (11:00 - 14:00)', value: 'Mediodia' },
                  { label: 'Tarde (14:00 - 17:00)', value: 'Tarde' }
                ]"
                item-text="label"
                item-value="value"
                label="Franja"
                dense
                outlined
              />
              <v-btn small class="mt-2" color="primary" @click="addOpcion" :disabled="opciones.length >= maxOpciones">
                Añadir opción ({{ opciones.length }}/{{ maxOpciones }})
              </v-btn>
              <div class="caption grey--text mt-1">Añade hasta {{ maxOpciones }} combinaciones día+franja.</div>
            </v-col>
          </v-row>

          <!-- Lista de opciones añadidas -->
          <v-row dense v-if="opciones.length">
            <v-col cols="12">
              <div class="mb-2 font-weight-bold">Tus opciones</div>
              <v-chip-group multiple column>
                <v-chip
                  v-for="(op, i) in opciones"
                  :key="op.fecha + '_' + op.franja"
                  class="ma-1"
                  close
                  @click:close="removeOpcion(i)"
                >
                  {{ op.fecha }} — {{ op.franja }}
                </v-chip>
              </v-chip-group>
            </v-col>
          </v-row>
          
         <v-row class="mt-4">
          <v-col cols="12">
            <div class="mb-2 font-weight-bold">Indica un teléfono para ponernos en contacto si es necesario:</div>

            <v-text-field
              v-model="telefono"
              label="Teléfono"
              outlined
              prepend-inner-icon="mdi-phone"
              type="tel"
              :rules="[
                v => !!v || 'El teléfono es obligatorio',
                v => /^[0-9]{9}$/.test(v) || 'Debe contener 9 dígitos'
              ]"
              maxlength="9"
              counter
            />
          </v-col>
        </v-row>

          <v-row class="mt-4">
            <v-col cols="12">
              <div class="mb-2 font-weight-bold">Observaciones</div>
              <v-textarea
                v-model="observaciones"
                outlined
                rows="3"
                auto-grow
                label="Escribe aquí cualquier información adicional (opcional)"
              />
            </v-col>
          </v-row>
        </template>

        <!-- Firma -->
        <v-divider class="my-4"/>
        <div class="mb-2 font-weight-bold">Firma</div>
        <div class="caption grey--text mb-2">Firma dentro del recuadro (ratón o dedo).</div>
        <div style="border:1px dashed #bbb; border-radius:8px; padding:8px; background:#fafafa;">
          <canvas ref="firmaCanvas" style="width:100%; height:180px; background:white; border-radius:6px;"></canvas>
        </div>
        <div class="mt-2">
          <v-btn small text @click="limpiarFirma">Limpiar firma</v-btn>
        </div>

        <!-- Guardar -->
        <v-divider class="my-4"/>
        <div class="text-right">  						
          <v-btn color="primary" :loading="loading" @click="onClickSaveData">
            Guardar y generar PDF
          </v-btn>
        </div>
      </v-card>
    </v-card>
  </v-container>
 

</template>

<script>
import axios from "axios";
import SignaturePad from "signature_pad";
import { mapState } from "vuex";

export default {
  name: "ReconocimientoMedico",
  computed: {
    ...mapState(['empId', 'perId', 'perAux', 'esEmpleado', 'urlRaiz', 'per']),
    puedeVer() {
      // ⚠️ Cambia 'RecoMedicoHabilitado' por el nombre real del flag en tu store/BD
      return !!(this.per && this.per.rivaId != 1);
    },
    perNombre() {
      return this.per && this.per.PerNom ? this.per.PerNom : "empleado/a";
    },
    hoyISO() {
      const d = new Date();
      d.setDate(d.getDate() + 15); // sumamos 15 días

      const m = `${d.getMonth() + 1}`.padStart(2, "0");
      const day = `${d.getDate()}`.padStart(2, "0");
      return `${d.getFullYear()}-${m}-${day}`;
    },
    descripcionHtml() {
      // Si tenéis un "legal" aparte, podrías traerlo en la API /get; aquí muestro la descripción del cuestionario
      return this.descripcion || "";
    },
    logoSrc() {
      const emp = Number(this.empId);

        // grupos (ajusta si cambian)
       const martinIds = [8, 12, 15];
       const rinconIds = [1, 2, 3, 11, 14];

       // priorizamos por grupo
       if (martinIds.includes(emp)) {
         return "https://www.martinmartin.es/wp-content/uploads/2025/01/logo-40.png";
       }
       if (rinconIds.includes(emp)) {
         return "https://d23esi1h40dfmi.cloudfront.net/wp-content/uploads/2021/06/08083209/Logo_2_tintas-e1623141346682.png";
       }
       // por defecto
       return "https://d23esi1h40dfmi.cloudfront.net/wp-content/uploads/2021/06/08083209/Logo_2_tintas-e1623141346682.png";
      }
  },
  data: () => ({
    logoUrl: "https://d23esi1h40dfmi.cloudfront.net/wp-content/uploads/2021/06/08083209/Logo_2_tintas-e1623141346682.png",
    loading: false,
    cuestionario: { Preguntas: [] },
    // IDs de tus preguntas
    P_DECISION: 35,
    P_DISPONIBILIDAD: 36,
    P_FRANJA: 37,
    P_OBSERVACIONES: 39,
    P_TELEFONO: 40,

    // Modelo de respuestas
    decision: null,              // "SI" | "NO" (P35)
    fechas: [],                  // array yyyy-MM-dd (P36)
    franja: null,                // "Mañanas" | "Tardes" | "Indiferente" (P37)
    franjaItems: [],

    firmaPad: null,

    dialogLegal: false,
    dialogDisponibilidad: false,

    selFecha: null,        // Día seleccionado en el date-picker
    selFranja: null, 
    opciones: [],          // [{ fecha: '2025-10-01', franja: 'Mañanas' }, ...]
    maxOpciones: 4,
    observaciones: "",   // texto libre cuando decision = "SI"
    telefono: "",
    puedeVerCuestionario: false,
    descripcion: "",
    festivos: [
      // Fechas sueltas bloqueadas (formato YYYY-MM-DD)
      '2025-12-08',
      '2025-12-25',
      '2026-01-29',
    ],
    rangosCerrados: [
      // Rangos (ambos inclusive)
      { desde: '2025-12-22', hasta: '2026-01-11' },
    ],

  }),
  methods: {
    async loadData() {
      this.loading = true;
      try {
        const AuthToken = localStorage.getItem('token');
        const controllerParameters = { Titulo: 'RECONOCIMIENTO MEDICO VOLUNTARIO', PerId: this.perId, ReconocimientoMedico: true };

        const { data } = await axios({
          method: "POST",
          url: this.urlRaiz + "/api/cuestionario/get",
          data: JSON.stringify(controllerParameters),
          headers: { "content-type": "application/json", "Authorization": AuthToken }
        });

        const item = data.Cuestionario || {};
        //this.puedeVerCuestionario = data.Respuesta;
        if(data.Respuesta === "1"){
          this.puedeVerCuestionario =true;
        }else{
          this.puedeVerCuestionario =false;
        }
        this.descripcion = data.descripcion;
        // Normaliza estructura: esperamos item.Preguntas con las PreguntasCuestionario
        // Si te llega con otro nombre (p.ej. item.PreguntasCuestionario), ajusta aquí.
        item.Preguntas = item.Preguntas || item.PreguntasCuestionario || [];

        // Parsear items de franja desde P37.Respuestas (si vienen en JSON)
        this.cuestionario = item;
      } catch (e) {
        alert("Error al cargar el cuestionario");
      } finally {
        this.loading = false;
        this.$nextTick(this.initFirma);
      }
    },
    parseLocal (iso) {
      const [y, m, d] = iso.split('-').map(Number);
      return new Date(y, m - 1, d);
    },
    allowedDates (iso) {
      // Bloquear sábados y domingos
      const dt = this.parseLocal(iso);
      const dow = dt.getDay(); // 0=Domingo, 6=Sábado
      if (dow === 0 || dow === 6) return false;

      // Bloquear festivos sueltos
      if (this.festivos.includes(iso)) return false;

      // Bloquear rangos
      for (const r of this.rangosCerrados) {
        if (iso >= r.desde && iso <= r.hasta) return false;
      }

      return true; // Permitido
    },
    initFirma() {
      const canvas = this.$refs.firmaCanvas;
      if (!canvas) return;
      const ratio = Math.max(window.devicePixelRatio || 1, 1);
      const rect = canvas.getBoundingClientRect();
      canvas.width = rect.width * ratio;
      canvas.height = rect.height * ratio;
      const ctx = canvas.getContext("2d");
      ctx.scale(ratio, ratio);
      this.firmaPad = new SignaturePad(canvas, { minWidth: 1, maxWidth: 2.5, penColor: "#000", backgroundColor: "#fff" });
    },
    limpiarFirma() {
      this.firmaPad?.clear();
    },

    addOpcion() {
      if (!this.selFecha) {
        alert('Selecciona un día.');
        return;
      }
      if (!this.selFranja) {
        alert('Selecciona una franja para ese día.');
        return;
      }
      if (this.opciones.length >= this.maxOpciones) {
        alert(`Solo puedes añadir ${this.maxOpciones} opciones.`);
        return;
      }
      // evita duplicados exactos
      const existe = this.opciones.some(o => o.fecha === this.selFecha && o.franja === this.selFranja);
      if (existe) {
        alert('Esa combinación día+franja ya está en la lista.');
        return;
      }
      this.opciones.push({ fecha: this.selFecha, franja: this.selFranja });
    },

    removeOpcion(index) {
      this.opciones.splice(index, 1);
    },
    validar() {
      if (!this.esEmpleado) {
        alert('Debes iniciar sesión con tu usuario personal.');
        this.$router.push('/');
        return false;
      }
      if (!this.decision) {
        alert('Selecciona si aceptas o no el reconocimiento.');
        return false;
      }
      if (this.firmaPad?.isEmpty()) {
        alert('Por favor, firma el documento.');
        return false;
      }
      if (this.decision === 'SI') {
        // if (!this.franja) {
        //   alert('Selecciona franja preferente.');
        //   return false;
        // }
        // if (!this.fechas || this.fechas.length === 0) {
        //   alert('Selecciona al menos una fecha disponible.');
        //   return false;
        // }
        if (!this.opciones.length) {
          alert('Añade al menos una opción (día + franja).');
          return false;
        }
        if (!this.telefono) {
          alert('Añade un telefono de contacto.');
          return false;
        }
        if (this.opciones.length < this.maxOpciones) {
          // Si quieres forzar 4 exactas, descomenta:
          // alert(`Añade ${this.maxOpciones} opciones en total (día + franja).`);
          // return false;
        }
      }
      return true;
    },
    async onClickSaveData() {
      if (!this.validar()) return;
      try {
        this.loading = true;

        // Construye RespuestasUsuario como texto legible
        const respuestas = [];
        respuestas.push({
          PreguntasCuestionarioId: this.P_DECISION,
          respuestaUsuario: this.decision
        });

        if (this.decision === 'SI') {
          const listado = this.opciones
            .slice() // copia
            .sort((a,b) => a.fecha.localeCompare(b.fecha))
            .map(o => `${o.fecha} (${o.franja})`)
            .join('; ');
          // P36: Disponibilidad (pares)
          respuestas.push({
            PreguntasCuestionarioId: this.P_DISPONIBILIDAD,
            respuestaUsuario: listado
          });
          // P37 (Franja) — opcional: al haber múltiples, puedes poner "Varias" o eliminar esta respuesta
          respuestas.push({
            PreguntasCuestionarioId: this.P_FRANJA,
            respuestaUsuario: 'Varias'
          });

          if (this.observaciones && this.observaciones.trim() !== "") {
            respuestas.push({
              PreguntasCuestionarioId: this.P_OBSERVACIONES,
              respuestaUsuario: this.observaciones
            })
          }

          if (this.telefono && this.telefono.trim() !== "") {
            respuestas.push({
              PreguntasCuestionarioId: this.P_TELEFONO,
              respuestaUsuario: this.telefono
            })
          }
        }

        const payload = {
          CuestionarioId: this.cuestionario.CuestionarioId,
          PerId: this.perId,
          DirId: 0,

          Decision: this.decision,
          // Enviamos opciones como estructura para el PDF del back
          Disponibilidad: this.decision === 'SI' ? {
            Tipo: 'pares',
            Opciones: this.opciones, // [{fecha, franja}],
            Observaciones: this.observaciones,
            Telefono: this.telefono
          } : null,

          FirmaBase64: this.firmaPad.toDataURL("image/png"),
          FechaFirmaISO: new Date().toISOString(),

          Respuestas: respuestas
        };

        const AuthToken = localStorage.getItem('token');
        const { data } = await axios({
          method: "POST",
          url: this.urlRaiz + "/api/cuestionario/respuesta/saveReconocimiento",
          data: JSON.stringify(payload),
          headers: { "content-type": "application/json", "Authorization": AuthToken }
        });

        if (data?.Success) {
          alert('Guardado correctamente. Has recibido una copia en tu email personal');
          this.$router.push('/');
        } else {
          alert(data?.Message || "No se ha podido guardar. Ponte en contacto con Recursos Humanos");
        }
      } catch (e) {
        alert("Error al guardar.");
      } finally {
        this.loading = false;
      }
    }
    // async onClickSaveData() {

    //   if (!this.puedeVer) {
    //     alert('No tienes permisos para usar este formulario.');
    //     this.$router.push('/');
    //     return;
    //   }
    //   if (!this.validar()) return;
    //   try {
    //     this.loading = true;
    //     const P_DECISION = 35;
    //     const P_DISPONIBILIDAD = 36;
    //     const P_FRANJA = 37;

    //     const respuestas = [
    //       { PreguntasCuestionarioId: P_DECISION,     respuestaUsuario: this.decision } // "SI"/"NO"
    //     ];

    //     if (this.decision === 'SI') {
    //       const dispoTexto = `Fechas: ${[...this.fechas].sort().join(', ')}`;
    //       respuestas.push(
    //         { PreguntasCuestionarioId: P_DISPONIBILIDAD, respuestaUsuario: dispoTexto },
    //         { PreguntasCuestionarioId: P_FRANJA,         respuestaUsuario: this.franja }
    //       );
    //     }

    //     const payload = {
    //       Respuestas: respuestas,              
    //       CuestionarioId: this.cuestionario.CuestionarioId,
    //       PerId: this.perId,
    //       DirId: 0,
    //       // extras para firma/pdf (los recogerá el back SIN romper tu guardado actual)
    //       FirmaBase64: this.firmaPad.toDataURL("image/png"),
    //       FechaFirmaISO: new Date().toISOString(), // opcional
    //       // opcional, por comodidad al PDF:
    //       Decision: this.decision,
    //       Disponibilidad: this.decision === 'SI'
    //         ? { Tipo: 'calendario', Fechas: this.fechas, Franja: this.franja }
    //         : null
    //     };

    //     const AuthToken = localStorage.getItem('token');

    //     const { data } = await axios({
    //       method: "POST",
    //       url: this.urlRaiz + "/api/cuestionario/respuesta/saveReconocimiento",
    //       data: JSON.stringify(payload),
    //       headers: { "content-type": "application/json", "Authorization": AuthToken }
    //     });

    //     if (data?.Success) {
    //       alert('Guardado correctamente.');
    //       // Si quieres abrir el PDF:
    //       //window.open(this.urlRaiz + "/api/files/get?path=" + encodeURIComponent(data.PdfPath), "_blank");
    //       this.$router.push('/');
    //     } else {
    //       alert(data?.Message || "No se ha podido guardar.");
    //     }
    //   } catch (e) {
    //     alert("Error al guardar." + e);
    //   } finally {
    //     this.loading = false;
    //   }
    // }
  },
  mounted() {
    this.loadData();
  }
};
</script>
